import type { NFTStakingPosition } from "@stepfinance/nft";
import { useMemo } from "react";

import { DUST_THRESHOLD, useHideDustConfig } from "../../contexts/app/config";
import { useStarAtlasShipStakingQuery } from "../queries/nft/useStarAtlasShipStakingQuery";

interface NFTStakingHook {
  nftPositions: NFTStakingPosition[];
  refresh(): void;
}

/**
 * Generalized hook for all staked NFT's. Only Star Atlas supported so far.
 */
export const useNFTStaking = (): NFTStakingHook => {
  const { data: positions, isSuccess, refetch } = useStarAtlasShipStakingQuery();
  const { hideDust } = useHideDustConfig();

  const nftPositions = useMemo(() => {
    if (hideDust && isSuccess) {
      return positions.filter((p) => {
        const pendingRewardUSD = p.pendingRewardUSD || 0;
        const posValue = (p.valueInUSD ?? 0) + pendingRewardUSD;
        return (posValue || 0) > DUST_THRESHOLD;
      });
    }
    return positions ?? [];
  }, [hideDust, isSuccess, positions]);

  return {
    nftPositions,
    refresh: refetch,
  };
};
